export default __webpack_public_path__ + "static/media/Background_00182.05f716c9.png";